module.exports = __webpack_public_path__ + "img/2x.c0d62b7.jpg";